
import { useSession } from "@/providers/SessionProvider";
import { UserTypes } from '@/configs/AppConfig';
import { MOD_AUTH } from "@/configs/ModulesConfig"
import api from "@/api/api"
import { toast } from "sonner"
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import UserSessionService from '@/lib/UserSessionService'


// const fetchRights = async (userType) => {
//     const api_url = userType == UserTypes.SYSTEM_USER ? MOD_AUTH.api_system_user.reloadRights : MOD_AUTH.api_app_user.reloadRights
//     const response = await api.post(api_url)
//     const badRequest = response.status !== 201
//     const statusCode = response?.data?.status
//     const message = response?.data?.message || 'You do not have rights'
//     const data = response.data

//     if (badRequest || statusCode < 0 || !data?.sessionDependencies) {
//         throw {
//             message: message
//         };
//     }
//     return data?.sessionDependencies
// };

export default function RightsManager() {
    // const { userType, updateRights } = useSession()
    // useQuery({
    //     enabled: userType !== UserTypes.GUEST,
    //     queryKey: ['userRights', userType],
    //     queryFn: () => {
    //         const qData = fetchRights(userType).then(data => {
    //             userType == UserTypes.SYSTEM_USER && updateRights(data?.accessibleModuleCodes)
    //         }).catch(err => {
    //             console.error(err)
    //             const msg = err?.message || err?.response?.data?.error || err?.response?.data?.message;
    //             toast.error(msg)
    //             updateRights([], true)
    //         })
    //         return { data: '' }
    //     },
    //     refetchInterval: 30 * 60 * 1000,
    //     refetchIntervalInBackground: true,
    // });

    return <></>
}; 